<template>
  <div>
    <a-card class="container" :body-style="{ padding: 0 }">
      <div class="layout">
        <!-- 左侧功能导航 -->
        <div class="side">
          <div class="side-title">
            <a-icon type="safety-certificate" />
            权限管理
          </div>
          <div
            v-for="item in menus"
            :key="item.key"
            class="side-item"
            :class="{ active: active === item.key }"
            @click="active = item.key"
          >
            <a-icon :type="item.icon" />
            <span>{{ item.title }}</span>
          </div>
          <div class="side-tip">权限模型：用户 → 岗位 → 角色 → 功能权限</div>
        </div>
        <!-- 右侧内容区 -->
        <div class="content">
          <position-manage v-show="active === 'position'" />
          <data-permission-define v-show="active === 'define'" />
          <user-data-permission v-show="active === 'user'" />
          <sql-test v-show="active === 'test'" />
          <review-config v-show="active === 'review'" />
        </div>
      </div>
    </a-card>
  </div>
</template>

<script>
import PositionManage from "./components/position-manage";
import DataPermissionDefine from "./components/data-permission-define";
import UserDataPermission from "./components/user-data-permission";
import SqlTest from "./components/sql-test";
import ReviewConfig from "./components/review-config";

export default {
  name: "authPermission",

  components: {
    PositionManage,
    DataPermissionDefine,
    UserDataPermission,
    SqlTest,
    ReviewConfig,
  },

  data() {
    return {
      active: "position",
      menus: [
        { key: "position", title: "岗位管理", icon: "idcard" },
        { key: "define", title: "数据权限定义", icon: "database" },
        { key: "user", title: "用户特殊权限", icon: "user-add" },
        { key: "test", title: "权限SQL测试", icon: "code" },
        { key: "review", title: "审批节点配置", icon: "audit" },
      ],
    };
  },
};
</script>

<style scoped>
.layout {
  display: flex;
  min-height: calc(100vh - 200px);
}
.side {
  width: 200px;
  flex-shrink: 0;
  border-right: 1px solid #e8e8e8;
  padding: 16px 0;
  background: #fafafa;
}
.side-title {
  font-size: 15px;
  font-weight: 600;
  padding: 0 20px 12px;
  color: rgba(0, 0, 0, 0.85);
}
.side-item {
  padding: 10px 20px;
  cursor: pointer;
  color: rgba(0, 0, 0, 0.65);
  transition: all 0.2s;
  white-space: nowrap;
}
.side-item:hover {
  color: #1890ff;
}
.side-item.active {
  color: #1890ff;
  background: #e6f7ff;
  border-right: 2px solid #1890ff;
}
.side-tip {
  margin-top: 24px;
  padding: 12px 16px;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.45);
  line-height: 1.6;
}
.content {
  flex: 1;
  padding: 16px 24px;
  min-width: 0;
}
</style>
